import type { KeyboardEvent, PropsWithChildren, SyntheticEvent } from 'react';
import {
  Popper,
  Fade,
  Paper,
  ClickAwayListener,
  MenuList,
  type PopperProps,
} from '@mui/material';

type MenuProps = {
  anchorEl?: PopperProps['anchorEl'];
  placement?: PopperProps['placement'];
  open: boolean;
  onClose: (event: Event | SyntheticEvent) => void;
};

const Menu = ({
  anchorEl,
  children,
  open,
  placement = 'bottom-end',
  onClose,
}: PropsWithChildren<MenuProps>) => {
  const handleListKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'Tab') {
      event.preventDefault();
      onClose(event);
    } else if (event.key === 'Escape') {
      onClose(event);
    }
  };

  return (
    <Popper
      anchorEl={anchorEl}
      open={open}
      placement={placement}
      transition
      disablePortal
      style={{ zIndex: 9 }}
    >
      {({ placement, TransitionProps }) => (
        <Fade
          {...TransitionProps}
          style={{
            transformOrigin:
              placement === 'bottom-start' ? 'left top' : 'left bottom',
          }}
        >
          <Paper
            sx={{
              borderRadius: 0,
              boxShadow: '0px 3px 6px rgba(0, 0, 0, .29)',
            }}
          >
            <ClickAwayListener onClickAway={onClose}>
              <MenuList autoFocusItem={open} onKeyDown={handleListKeyDown}>
                {children}
              </MenuList>
            </ClickAwayListener>
          </Paper>
        </Fade>
      )}
    </Popper>
  );
};

export default Menu;
